import { render, staticRenderFns } from "./taolijin.vue?vue&type=template&id=4c1409e4&scoped=true&"
import script from "./taolijin.vue?vue&type=script&lang=js&"
export * from "./taolijin.vue?vue&type=script&lang=js&"
import style0 from "./taolijin.vue?vue&type=style&index=0&id=4c1409e4&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c1409e4",
  null
  
)

export default component.exports